import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_c6475175-9a65-4c2a-91e3-a6c8195373e3/artifacts/ccxbep84_Logo.png";
const WHATSAPP_NUMBER = "8898798857";
const PHONE_NUMBER = "+918898798857";

const navLinks = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Services", path: "/services" },
  { name: "Gallery", path: "/gallery" },
  { name: "Contact", path: "/contact" },
];

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const handleBookAppointment = () => {
    const message = encodeURIComponent("Hi, I'd like to book an appointment at Bunty Hair Master.");
    window.open(`https://wa.me/91${WHATSAPP_NUMBER}?text=${message}`, "_blank");
  };

  return (
    <header 
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/10"
      data-testid="main-header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex items-center gap-3"
            data-testid="header-logo-link"
          >
            <img 
              src={LOGO_URL} 
              alt="Bunty Hair Master" 
              className="h-12 w-auto"
            />
            <span className="hidden sm:block font-['Playfair_Display'] text-lg text-white">
              Bunty Hair Master
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-link text-sm tracking-wide ${
                  location.pathname === link.path ? "text-[#D4AF37]" : ""
                }`}
                data-testid={`nav-link-${link.name.toLowerCase()}`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-4">
            <a 
              href={`tel:${PHONE_NUMBER}`}
              className="flex items-center gap-2 text-white/80 hover:text-[#D4AF37] transition-colors"
              data-testid="header-phone-link"
            >
              <Phone className="w-4 h-4" />
              <span className="text-sm">+91 88987 98857</span>
            </a>
            <Button
              onClick={handleBookAppointment}
              className="bg-[#D4AF37] text-black hover:bg-[#B5952F] font-medium px-6 py-2 rounded-none shadow-[0_0_15px_rgba(212,175,55,0.3)] hover:shadow-[0_0_25px_rgba(212,175,55,0.5)] transition-shadow"
              data-testid="header-book-btn"
            >
              Book Appointment
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div 
          className="lg:hidden bg-[#0A0A0A] border-t border-white/10"
          data-testid="mobile-menu"
        >
          <nav className="px-6 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block py-3 text-lg font-medium ${
                  location.pathname === link.path 
                    ? "text-[#D4AF37]" 
                    : "text-white/80"
                }`}
                onClick={() => setMobileMenuOpen(false)}
                data-testid={`mobile-nav-link-${link.name.toLowerCase()}`}
              >
                {link.name}
              </Link>
            ))}
            <div className="pt-4 border-t border-white/10">
              <Button
                onClick={() => {
                  handleBookAppointment();
                  setMobileMenuOpen(false);
                }}
                className="w-full bg-[#D4AF37] text-black hover:bg-[#B5952F] font-medium py-3 rounded-none"
                data-testid="mobile-book-btn"
              >
                Book Appointment
              </Button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
